import { type IconDefinition } from '@fortawesome/fontawesome-common-types';
import {
    faMoonStars,
    faSun,
    faSunrise,
    faSunset,
} from '@fortawesome/pro-regular-svg-icons';
import type { TimeRange } from '@clients/PricetrackApi';

export interface TimeItem {
    label: string;
    subLabel: string;
    icon?: IconDefinition;
    items: Radio<{ from?: string; to?: string }>[];
}

export function compareTimeRanges(t1: TimeRange, t2: TimeRange) {
    return t1.from === t2.from && t1.to === t2.to;
}

export const timeItems: TimeItem[] = [
    {
        label: 'بامداد',
        subLabel: '۰ الی ۶ صبح',
        icon: faSunrise,
        items: [
            { label: '00:00 تا 02:00', value: { from: '00:00', to: '02:00' } },
            { label: '02:00 تا 04:00', value: { from: '02:00', to: '04:00' } },
            { label: '04:00 تا 06:00', value: { from: '04:00', to: '06:00' } },
        ],
    },
    {
        label: 'قبل از ظهر',
        icon: faSun,
        subLabel: '۶ صبح الی ۱۲ ظهر',
        items: [
            { label: '06:00 تا 08:00', value: { from: '06:00', to: '08:00' } },
            { label: '08:00 تا 10:00', value: { from: '08:00', to: '10:00' } },
            { label: '10:00 تا 12:00', value: { from: '10:00', to: '12:00' } },
        ],
    },
    {
        label: 'بعد از ظهر',
        subLabel: '۱۲ ظهر الی ۱۸ عصر',
        icon: faSunset,
        items: [
            { label: '12:00 تا 14:00', value: { from: '12:00', to: '14:00' } },
            { label: '14:00 تا 16:00', value: { from: '14:00', to: '16:00' } },
            { label: '16:00 تا 18:00', value: { from: '16:00', to: '18:00' } },
        ],
    },
    {
        label: 'شب',
        subLabel: '۱۸ عصر الی ۲۴ نیمه شب',
        icon: faMoonStars,
        items: [
            { label: '18:00 تا 20:00', value: { from: '18:00', to: '20:00' } },
            { label: '20:00 تا 22:00', value: { from: '20:00', to: '22:00' } },
            { label: '22:00 تا 24:00', value: { from: '22:00', to: '23:59' } },
        ],
    },
];

export const autoReserveLocalStorageKeys = {
    revivePackage: 'auto-reserve-revive-data',
};
